// 部门信息更新申请
import axios from "../axios";


/**
 * 通过会员信息修改申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const approvalDeptExtendUpdateRecord = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/approvalDeptExtendUpdateRecord  ',
    method: 'post',
    data
  })
}

/**
 * 驳回会员信息修改申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const rejectDeptExtendUpdateRecord = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/rejectDeptExtendUpdateRecord',
    method: 'post',
    data
  })
}

// 通过部门Id查询信息
export const getDeptExtendUpdateRecordByDeptId = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/getDeptExtendUpdateRecordByDeptId  ',
    method: 'post',
    data
  })
}

/**
 * 获取会员信息修改申请已审核列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendUpdateRecordListOfApproved = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/getDeptExtendUpdateRecordListOfApproved',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 获取会员信息修改申请待审核列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendUpdateRecordListOfUnApproval = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/getDeptExtendUpdateRecordListOfUnApproval    ',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 * 获取会员信息修改申请审核不通过列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendUpdateRecordListOfApprovalNoPass = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/getDeptExtendUpdateRecordListOfApprovalNoPass    ',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const getDeptExtendUpdateRecordByCondition = data => {
  return axios({
    url: 'mDeptExtendUpdateRecord/getDeptExtendUpdateRecordByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 * 保存修改后的信息
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const save = (data, params) => {
  return axios({
    url: 'mDeptExtendUpdateRecord/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params
  })
}
/**
 * 保存修改后的信息
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const submitDeptExtendUpdateRecord = (data) => {
  return axios({
    url: 'mDeptExtendUpdateRecord/submitDeptExtendUpdateRecord',
    method: 'post',
    data,
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/deptExtendUpdateRecord.js